import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Badge,
  Spinner,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Card,
  CardHeader,
  CardBody,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiActivity } from 'react-icons/fi';

/**
 * TicketsRecentes - Component for displaying recent tickets
 * 
 * @param {Object} props - Component props
 * @param {Array} props.tickets - Array of ticket objects
 * @param {boolean} props.isLoading - Loading state
 */
const TicketsRecentes = ({ tickets, isLoading }) => {
  const cardBg = useColorModeValue('white', 'gray.700');
  const tableBg = useColorModeValue('gray.50', 'gray.700');
  
  // Status badge colors
  const getStatusColor = (status) => {
    switch (status) {
      case 'Resolvido':
        return 'green';
      case 'Em atendimento':
        return 'blue';
      case 'Aguardando cliente':
        return 'yellow';
      case 'Novo':
        return 'purple';
      case 'Reaberto':
        return 'orange';
      default:
        return 'gray';
    }
  };
  
  // Priority colors
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'Alta':
        return 'red';
      case 'Média':
        return 'orange';
      case 'Baixa':
        return 'green';
      default:
        return 'gray';
    }
  };

  return (
    <Card bg={cardBg} boxShadow="md">
      <CardHeader pb={2}>
        <Flex justify="space-between" align="center">
          <Heading size="md">Tickets Recentes</Heading>
          <Badge colorScheme="blue" px={3} py={1} borderRadius="full">
            {isLoading ? '-' : tickets.length} tickets
          </Badge>
        </Flex>
      </CardHeader>
      <CardBody px={{ base: 2, md: 4 }}>
        {isLoading ? (
          <Flex justify="center" py={6}>
            <Spinner />
          </Flex>
        ) : (
          <Box overflowX="auto">
            <Table variant="simple" size="sm">
              <Thead bg={tableBg}>
                <Tr>
                  <Th>ID</Th>
                  <Th>Cliente</Th>
                  <Th>Assunto</Th>
                  <Th>Prioridade</Th>
                  <Th>Status</Th>
                  <Th>Tempo</Th>
                  <Th>Atendente</Th>
                </Tr>
              </Thead>
              <Tbody>
                {tickets.map(ticket => (
                  <Tr key={ticket.id}>
                    <Td fontWeight="medium">{ticket.id}</Td>
                    <Td>{ticket.cliente}</Td>
                    <Td maxW="200px" isTruncated>{ticket.assunto}</Td>
                    <Td>
                      <Badge colorScheme={getPriorityColor(ticket.prioridade)}>
                        {ticket.prioridade}
                      </Badge>
                    </Td>
                    <Td>
                      <Badge colorScheme={getStatusColor(ticket.status)}>
                        {ticket.status}
                      </Badge>
                    </Td>
                    <Td>{ticket.tempo}</Td>
                    <Td>{ticket.atendente}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        )}
        <Flex justify="center" mt={4}>
          <Button 
            leftIcon={<FiActivity />} 
            colorScheme="yellow" 
            variant="outline" 
            size="sm"
          >
            Ver Todos os Tickets
          </Button>
        </Flex>
      </CardBody>
    </Card>
  );
};

export default TicketsRecentes;